import { render } from "./RiNotification.vue?vue&type=template&id=7beabc90"
import script from "./RiNotification.vue?vue&type=script&lang=js"
export * from "./RiNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7beabc90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7beabc90', __exports__)) {
    api.reload('7beabc90', __exports__)
  }
  
  module.hot.accept("./RiNotification.vue?vue&type=template&id=7beabc90", () => {
    api.rerender('7beabc90', render)
  })

}


export default __exports__